module.exports = __webpack_public_path__ + "img/biaoyang_img.1b297eec.png";